export default "__VITE_ASSET__CJEEI1Dq__"